import './style.scss'
import Layer from '../../../Shared/Layer'
import { Trans, useTranslation } from 'react-i18next'
import { Col, Container, Row } from '@trendmicro/react-grid-system'
import PropTypes from 'prop-types'
import Button from '../../Form/Button'
import { BUTTON_MIN_WIDTH } from '../../Form/Button/constants'

const PricingResetConfirmationOverlay = ({ onCancel, onConfirm, countryName, type = 'country' }) => {
  const { t } = useTranslation()
  return (
    <Layer
      type="center"
      size="small"
      id={'pricing-reset-confirmation'}
      show={true}
      onHideClick={onCancel}
      background="light-grey"
      borderRadius="20px"
      showCloseIcon={false}
      className="pricing-reset-confirmation-overlay"
      closeOnEsc={true}
      disallowHiding={false}
    >
      <Container fluid>
        <Row>
          <Col xs={1}>
            <span className="pricing-reset-confirmation-overlay__currencies_icon"></span>
          </Col>
          <Col xs={11}>
            <Row>
              <div className="pricing-reset-confirmation-overlay__text">
                {
                  type === 'country'
                    ? <Trans
                      i18nKey="editProperty.factsheet.pricingResetConfirmationDialog.header.country"
                      values={{ countryName }}
                    />
                    : <Trans i18nKey="editProperty.factsheet.pricingResetConfirmationDialog.header.currency"/>
                }
                <br/>
                <br/>
                <Trans i18nKey="editProperty.factsheet.pricingResetConfirmationDialog.subheader"/>
              </div>
            </Row>
            <Row>
              <br/>
            </Row>
            <Row style={{ textAlign: 'center' }}>
              <Col>
                <Button
                  variant="neutral"
                  style={{ marginRight: 20 }}
                  onClick={onCancel}
                  minWidth={BUTTON_MIN_WIDTH}
                >
                  {t('BUTTON_CANCEL')}
                </Button>
                <Button
                  variant="attention"
                  onClick={onConfirm}
                  minWidth={BUTTON_MIN_WIDTH}
                >
                  {t('BUTTON_CONTINUE')}
                </Button>
              </Col>
            </Row>
          </Col>
        </Row>
      </Container>
    </Layer>
  )
}

PricingResetConfirmationOverlay.propTypes = {
  onCancel: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  countryName: PropTypes.string,
  type: PropTypes.oneOf(['country', 'currency']),
}

export default PricingResetConfirmationOverlay
